
import { VListItemContent } from "vuetify/lib";

// Functional component
export default VListItemContent;
